if(document.querySelector('.laura-works .glide')) {
  let glide = new Glide('.laura-works .glide', {
    perView: 5,
    autoheight: true,
    breakpoints: {
      1020: {
        perView: 4
      },
      850: {
        perView: 3
      },
      750: {
        perView: 2
      },
      450: {
        perView: 1
      }
    }
  }).mount();
  if(document.querySelectorAll('.laura-works .glide__slide').length < 4 && window.innerWidth > 800) {
    glide.disable();
  }

  function sameHeightGlides() {
    sameHeight('.laura-works .glide__slide');
    sameHeight('.laura-works .glide__content p:first-of-type');
  }

  document.addEventListener("DOMContentLoaded", (event) => {
    sameHeightGlides();

    window.addEventListener('resize', () => {
      sameHeightGlides();
    });
  });
}
